<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoDetalhar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoDetalhar">
			<form>
				<div class="formgroup">
					<div class="flex justify-content-center mt-3" *ngIf="loading">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid pt-3 px-3" *ngIf="entradaEstoque && !loading">

						<div class="col-12 card-simple mb-3">
							<div class="p-fluid p-formgrid grid">
								<div class="col-12 md:col-2">
									<label class="label-superior">Nº Entrada</label>
									<label class="label-inferior" id="descricao">{{ entradaEstoque.nfEntrada }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Data Entrada</label>
									<label class="label-inferior" id="bandeira">{{ entradaEstoque.dataNf | date:'dd/MM/yyyy' }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Total Entrada</label>
									<label class="label-inferior" id="transação">{{ entradaEstoque.totalNf | currency:'BRL' }}</label>
								</div>
								<div class="col-12 md:col-3">
									<label class="label-superior">Fornecedor</label>
									<label class="label-inferior" id="antencipacao">{{ entradaEstoque.fornecedor?.nomeFornecedor }}</label>
								</div>
								
								<div class="col-12 md:col-3">
									<label class="label-superior">Valor do Frete</label>
									<label class="label-inferior" id="operacao">{{ entradaEstoque.valorFrete | currency:'BRL' }}</label>
								</div>

							</div>
						</div>
						
					</div>
					
					<div class="w-full mb-5" *ngIf="entradaEstoque && !loading">
						<div>
							<h5>Produtos</h5>
						</div>
						<p-table #dt1 [value]="listaEntradaProduto" dataKey="id" [rows]="10" [rowHover]="true"
							styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
							styleClass=" p-datatable-sm">
							<ng-template pTemplate="header" >
								<tr>
									<th>
										<div>
											Código
										</div>
									</th>
									<th>
										<div>
											Descrição
										</div>
									</th>
									<th>
										<div>
											Estoque Atual
										</div>
									</th>
									<th>
										<div>
											Quantidade
										</div>
									</th>
									<th>
										<div>
											Valor de Compra
										</div>
									</th>
									<th>
										<div>
											Valor de Venda
										</div>
									</th>
									<th>
										<div>
											Validade Produto
										</div>
									</th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-item let-i="rowIndex">
								<tr>
									<td>
										<label>{{ item.itemProduto.codigo }}</label>
									</td>
									<td>
										<label>{{ item.itemProduto.descricao }}</label>
									</td>
									<td>
										<label>{{ item.itemProduto.estoqueAtual }} {{ item.itemProduto.descricaoUnidadeMedida }}</label>
									</td>
									<td>
										<label>{{ item.quantidade }}</label>
									</td>
									<td>
										<label>{{ item.valorCompra | currency:'BRL' }}</label>
									</td>
									<td>
										<label>{{ item.itemProduto.valorVenda | currency:'BRL' }}</label>
									</td>
									<td>
										<label>{{ item.validadeLote }}</label>
									</td>
									
								</tr>
							</ng-template>
							<ng-template pTemplate="summary">
								<div class="flex align-items-center justify-content-between">
									Há {{listaEntradaProduto ? listaEntradaProduto.length : 0 }} produtos inseridos na nota.
								</div>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="7">Nenhum produto cadastrado.</td>
								</tr>
							</ng-template>
						</p-table>
					</div>

					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loading">
						<div class="col-12 md:col-2">
							<button type="button"  pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined" routerLink="/apps/entrada"></button>
						</div>
					</div>

				</div>
			</form>
		</div>
	</div>
</div>